<div class="project-name-box">
    <h3 [innerHTML]="projectName"></h3>
</div>